import { map } from 'rxjs';
import { convertUnixToDate } from '@golden/gdk-base';
import { ADMIN_API } from '../AdminAPI';
export function createGreetingService(api) {
    return {
        getGreetingList(data) {
            return api.fetch(ADMIN_API.GET_GREETING, { data }).pipe(map((res) => {
                return {
                    ...res,
                    data: res.data.map((item) => convertUnixToDate(item, 'created_at'))
                };
            }));
        },
        getGreeting() {
            return api.fetch(ADMIN_API.GET_RANDOM_GREETING);
        },
        createGreeting(data) {
            return api.fetch(ADMIN_API.POST_GREETING, { data });
        },
        updateGreeting(id, data) {
            return api.fetch(ADMIN_API.PUT_GREETING, { data, config: { urlParams: { id } } });
        },
        deleteGreeting(id) {
            return api.fetch(ADMIN_API.DELETE_GREETING, { config: { urlParams: { id } } });
        }
    };
}
//# sourceMappingURL=GreetingService.js.map